// extracted by mini-css-extract-plugin
export default {"infoContainer":"style_infoContainer__V8A6h","titleAction":"style_titleAction__pFN+8","personnalData":"style_personnalData__mq0k0","fullname":"style_fullname__vr80P"};